import { useQuery } from "react-query";

// utils
import { useReactAppState } from "../../shared/containers/utils";
import { mlsCompetitionsAPI } from "../../shared/api/variables";
import { fetchClient } from "../../shared/api/fetching";
import { getWhiteListCompetitions } from "../utils";


function useMLSCompetitions() {
    const { apiList } = useReactAppState();

    const mlsCompetitionsEndpoint = mlsCompetitionsAPI();

    return useQuery({
        queryKey: ["mls-competitions"],
        queryFn: () => fetchClient({ endpoint: mlsCompetitionsEndpoint, apiURL: apiList?.statsAPI }),
        select: response => {
            const whiteListCompetitions = getWhiteListCompetitions(response?.competitions);
            return [{ competition_name: "All Competitions", competition_id: "all" }, ...whiteListCompetitions];
        },
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    })
}

export default useMLSCompetitions;
